module.exports = "/static/img/where_we_are_bg.png?4907a5f3228b9ea3b0799fc40dd20547";